<ui-table [collapsible]="true" [collapsibleRow]="false" [responsive]="true" [rows]="products()">
  <!-- Details -->
  <div name="category" uiTableColumn>
    <ng-template uiTableHeader>
      <span class="table-header">{{ category() }}</span>
    </ng-template>
    <ng-template let-item="item" uiTableCell>
      <div class="details" uiPartialProductImpression [partialProduct]="item" [position]="products().indexOf(item)">
        <img [alt]="item.name" [src]="item.thumbnailUrl" class="image">
        <div class="data">
          <span [title]="item.name" class="title">{{ item.name }}</span>
          <span>
            <span>{{ item.packagingUnit }}</span>
            @if (item.prices; as prices) {
              <div class="end-user-price">
                <span class="price">{{ prices.endUserPriceLabel }}:&nbsp;</span>
                @if (prices.endUser; as endUserPrice) {
                  <ui-product-prices-formatter
                    [showThousandthsPlace]="false"
                    [price]="endUserPrice"
                  ></ui-product-prices-formatter>
                } @else {
                  <span class="price">k. A.</span>
                }
              </div>
            }
          </span>
          @if (item.identifiers.gtin) {
            <span class="text-smaller">GTIN: {{ item.identifiers.gtin }}</span>
          }
        </div>
      </div>
    </ng-template>
  </div>

  <!-- Identifiers -->
  <div name="identifiers" uiTableColumn>
    <ng-template uiTableHeader>
      <span class="identifiers-header">
        <span>Art.-Nr.</span>
        @if (hasStableArticleNumber()) {
          <span>Stab. Art.-Nr.</span>
        }
      </span>
    </ng-template>
    <ng-template let-item="item" uiTableCell>
      <div class="identifiers">
        <span>{{ item.identifiers.sku }}</span>
        @if (hasStableArticleNumber()) {
          <span>{{ item.identifiers.articleNumberStable ?? '-' }}</span>
        }
      </div>
    </ng-template>
  </div>

  <!-- Labels & Badge -->
  <div name="labels" uiTableColumn>
    <ng-template let-item="item" uiTableCell>
      <div class="badge-price">
        <ui-product-labels [product]="item"></ui-product-labels>
      </div>
    </ng-template>
  </div>

  <div name="order-quantities" uiTableColumn>
    <ng-template uiTableHeader>
      <span class="order-quantities-header">
        <span>Bestellungen</span>
        <span class="subtext">(letzte 3 Monate)</span>
      </span>
    </ng-template>
    <ng-template let-item="item" uiTableCell>
      <ui-order-quantities [orderQuantities]="item.orderQuantities"></ui-order-quantities>
    </ng-template>
  </div>

  <!-- Prices -->
  @if (showPriceColumn()) {
    <div justifyContent="end" name="prices" uiTableColumn>
      <ng-template uiTableHeader>
        <span>Preis pro Stk.</span>
      </ng-template>
      <ng-template let-item="item" uiTableCell>
        @if (item.itemAvailable && item.prices) {
          <div class="prices">
            <ui-product-prices
              [productPrice]="item.prices"
              [showThousandthsPlace]="true"
            ></ui-product-prices>
          </div>
        } @else {
          -
        }
      </ng-template>
    </div>
  }

  <!-- Add to cart -->
  <ng-template let-item="item" uiTableRowActions>
    @if (item.itemAvailable) {
      <ui-add-to-cart
        [sku]="item.identifiers.sku"
        [defaultAmount]="1"
        [product]="item"
        [position]="products().indexOf(item)"
      ></ui-add-to-cart>
    }
  </ng-template>
</ui-table>
